import { useEffect, useState } from "react";
import { ChoiceData } from "@routes/Keyword/templates/AseanInsights/components/DownloadForm/actions/helpers/getChoicesData";
import { getChoicesFromBFF } from "@routes/Keyword/templates/AseanInsights/components/DownloadForm/actions/helpers/getChoicesFromBFF";
import { ASEAN_COUNTRY_EMARSYS_LABEL_MAP } from "@routes/Keyword/templates/AseanInsights/components/DownloadForm/utils/contants";

/** Helper function to get the priority countries from Emarsys. */
const getPriorityCountries = (
  countryChoices: ChoiceData[]
): DropdownOption[] => {
  return ASEAN_COUNTRY_EMARSYS_LABEL_MAP.map((country) => {
    const matchedChoice = countryChoices.find(
      (choice) => choice.choice === country.emarsysLabel
    );

    return {
      value: matchedChoice?.id ?? "",
      label: country.label,
    };
  }).filter((country) => country.value);
};

/** Helper function to get the other countries from Emarsys. */
const getOtherCountries = (countryChoices: ChoiceData[]): DropdownOption[] => {
  return countryChoices
    .filter(
      (choice) =>
        !ASEAN_COUNTRY_EMARSYS_LABEL_MAP.some(
          (label) => label.emarsysLabel === choice.choice
        )
    )
    .map((choice) => ({
      value: choice.id,
      label: choice.choice,
    }));
};

/** Helper to build the list of countries to display in the dropdown. */
const getCountries = (countryChoices: ChoiceData[]): DropdownOption[] => {
  return [
    ...getPriorityCountries(countryChoices),
    ...getOtherCountries(countryChoices),
  ];
};

/** Hook to get the countries from Emarsys. */
const useGetCountries = () => {
  const [countries, setCountries] = useState<DropdownOption[]>([]);

  useEffect(() => {
    const fetchCountries = async () => {
      const countryChoices: ChoiceData[] = await getChoicesFromBFF("14");

      const countries: DropdownOption[] = getCountries(countryChoices);
      setCountries(countries);
    };

    fetchCountries();
  }, []);

  return countries;
};

export default useGetCountries;
